import React from "react";
import { useStaticQuery, graphql } from "gatsby"
import loadable from "@loadable/component";
import { Link } from "gatsby"
import { Container, Row, Col } from "react-bootstrap";
import "./assets/styles/_index.scss";
import useSiteConfig from "../../hooks/useSiteConfig"
import { PageLinks } from "../../common/site/page-static-links";
const { CTALink } = require("@starberry/gatsby-theme-utils/Modules/CTALinkModule");
const { ContentModule } = require("@starberry/gatsby-theme-utils/Modules/ContentModule")
const FooterSocial = loadable(() => import("../FooterSocial/FooterSocial"));
const FooterCopyright = loadable(() => import("../FooterCopyright/FooterCopyright"));
const FooterSiteBy = loadable(() => import("../FooterSiteBy/FooterSiteBy"));

const Footer = (props) => {
    const { footer_links, footer_section } = useSiteConfig();
    const data = useStaticQuery(graphql`
        query {
            allStrapiSolution(filter: {publish: {eq: true}}) {
              edges {
                node {
                  ...SolutionFragment
                }
              }
            }
        }
    `);

    const solutionDet = data.allStrapiSolution?.edges;
    return (
        <footer className={`footer section-p104 ${props.withBottomCta}`}>
            <Container>
                <Row>
                    <Col xl={7}>
                        {footer_section?.content ? <ContentModule Content={footer_section.content?.data?.content} /> : ""}
                    </Col>
                    <Col xl={5} className="d-xl-flex justify-content-end">
                        {footer_section.cta_1_link || footer_section.cta_2_link ? <ul className="footer-cta list-inline">
                            {footer_section.cta_1_title && footer_section.cta_1_link &&
                                <li className="list-inline-item">
                                    <CTALink class="button button-primary-wbg" link={footer_section.cta_1_link} title={footer_section.cta_1_title} target_window={footer_section.cta_1_link.target_window} />
                                </li>
                            }
                            {footer_section.cta_2_title && footer_section.cta_2_link &&
                                <li className="list-inline-item">
                                    <CTALink class="button button-outline-white" link={footer_section.cta_2_link} title={footer_section.cta_2_title} target_window={footer_section.cta_2_link.target_window} />
                                </li>
                            }
                        </ul> : ""}
                    </Col>
                </Row>
                {/* <div className="line"></div> */}
                <Row className="footer-bottom section-p104">
                    {solutionDet && solutionDet.length > 0 && <Col xl={2} md={4} xs={6}>
                        <div className="footer-menu">
                            <div className="footer-menu-title">Our Spaces</div>
                            <ul className="footer-menu-list list-unstyled">
                                {solutionDet && solutionDet.map(({ node }, i) => (
                                    <li>
                                        <Link to={`/${PageLinks.solution}/${node.slug}`}>{node.title}</Link>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </Col>}
                    {footer_links && footer_links.map((item, index) => (
                        <Col xl={2} md={4} xs={6}>
                            <div className="footer-menu">
                                <div className="footer-menu-title">{item.title}</div>
                                <ul className="footer-menu-list list-unstyled">
                                    {item.add_link && item.add_link.map((node, i) => (
                                        <li>
                                            <CTALink link={node.link} title={node.title} target_window={node.link.target_window} />
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </Col>
                    ))}
                    <Col xl={6} md={12}>
                        <div className="footer-right-bottom">
                            <FooterSocial />
                            <FooterCopyright />
                            <FooterSiteBy />
                        </div>
                    </Col>
                </Row>
            </Container>
        </footer>
    );
};

export default Footer;
